{
  "$schema": "http://json-schema.org/draft-07/schema",
  "type": "object",
  "title": "Government Filing",
  "description": "A document or form used to register changes to a company with the government.",
  "properties": {
    "authorized_signatory": {
      "$ref": "#/definitions/authorized_signatory"
    },
    "company": { "$ref": "#/definitions/company" },
    "filing": { "$ref": "#/definitions/filing" }
  },
  "additionalProperties": false
}
